import {CustomField, CustomFieldValue} from "../../entities/CustomFieldName";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";

export class EditCustomFieldNameModel {
    static $inject = ['$q','CustomFieldNameService','NotificationService'];
    selectedCfn:CustomField;
    selectedHandheldCfn:CustomField;
    customFieldNames:CustomField[];
    hhCustomFieldNames:CustomField[];
    listValueAddText:string = null;
    selectedCfnv:CustomFieldValue;
    hhListValueAddText:string = null;
    selectedHhCfnv:CustomFieldValue;
    errorMessage:string = "";
    constructor(public $q:ng.IQService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }
    loadData():ng.IPromise<void>{
        return this.cfnService.getAll()
            .then((data)=>{
                this.customFieldNames = [];
                this.hhCustomFieldNames = [];
                for(var i=0;i<data.length;i++){
                    var cfn = CustomField.parseJson(data[i]);
                    this.customFieldNames.push(cfn);
                    this.hhCustomFieldNames.push(cfn);
                }
                //var i1= this.customFieldNames[0].displayIndex;
                //var i2= this.customFieldNames[1].displayIndex;
                //this.customFieldNames[0].displayIndex = i2;
                //this.customFieldNames[1].displayIndex = i1;
                //this.customFieldNames = data;
                this.customFieldNames.sort((a,b)=>{
                    return a.displayIndex - b.displayIndex;
                });
                this.hhCustomFieldNames.sort((a,b)=>{
                    return a.handheldDisplayIndex - b.handheldDisplayIndex;
                });
                return this.$q.when();
            })
            .catch((exc)=>{
                this.notifyService.notify("Error in getting locations:"+exc);
            });
    }
    save():ng.IPromise<boolean>{
        return this.cfnService.updateAll(this.customFieldNames);
    }
    moveUp(){
        var selectedItem = this.selectedCfn;
        if (selectedItem == null || selectedItem.displayIndex == 1)
            return;
        var selectedDisplayIndex = selectedItem.displayIndex;
        var indexOf = this.customFieldNames.indexOf(selectedItem);
        var itemAbove = this.customFieldNames[indexOf-1];
        selectedItem.displayIndex = itemAbove.displayIndex;
        itemAbove.displayIndex = selectedDisplayIndex;
        this.customFieldNames.sort((a,b)=>{
            return a.displayIndex - b.displayIndex;
        });
    }
    moveDown(){
        var selectedItem = this.selectedCfn;
        if (selectedItem == null || selectedItem.displayIndex == this.customFieldNames.length-1)
            return;
        var selectedDisplayIndex = selectedItem.displayIndex;
        var itemBelow = null;
        for(var i=0;i<this.customFieldNames.length;i++){
            if(this.customFieldNames[i].displayIndex == selectedDisplayIndex+1){
                itemBelow = this.customFieldNames[i];
                break;
            }
        }
        selectedItem.displayIndex = itemBelow.displayIndex;
        itemBelow.displayIndex = selectedDisplayIndex;
        this.customFieldNames.sort((a,b)=>{
            return a.displayIndex - b.displayIndex;
        });
    }
    hhMoveUp(){
        var selectedItem = this.selectedHandheldCfn;
        if (selectedItem == null || selectedItem.handheldDisplayIndex == 0)
            return;
        var indexOf = this.hhCustomFieldNames.indexOf(selectedItem);
        var itemAbove = this.hhCustomFieldNames[indexOf-1];
        var selectedDisplayIndex = selectedItem.handheldDisplayIndex;
        selectedItem.handheldDisplayIndex = itemAbove.handheldDisplayIndex;
        itemAbove.handheldDisplayIndex = selectedDisplayIndex;
        this.hhCustomFieldNames.sort((a,b)=>{
            return a.handheldDisplayIndex - b.handheldDisplayIndex;
        });
    }
    hhMoveDown(){
        var selectedItem = this.selectedHandheldCfn;
        if (selectedItem == null || selectedItem.handheldDisplayIndex == this.hhCustomFieldNames.length-1)
            return;
        var indexOf = this.hhCustomFieldNames.indexOf(selectedItem);
        var itemBelow = this.hhCustomFieldNames[indexOf+1];
        var selectedDisplayIndex = selectedItem.handheldDisplayIndex;
        selectedItem.handheldDisplayIndex = itemBelow.handheldDisplayIndex;
        itemBelow.handheldDisplayIndex = selectedDisplayIndex;
        this.hhCustomFieldNames.sort((a,b)=>{
            return a.handheldDisplayIndex - b.handheldDisplayIndex;
        });
    }
    listvalueAdd():void {
        if(this.listValueAddText.length != 0){
            var cfnv = new CustomFieldValue(this.selectedCfn.name,this.selectedCfn.customFieldValues.length,this.listValueAddText);
            this.selectedCfn.customFieldValues.push(cfnv);

        }
    }
    listvalueRemove():void{
        if(this.selectedCfnv != null){
            var cfnvIndex = this.selectedCfn.customFieldValues.indexOf(this.selectedCfnv);
            this.selectedCfn.customFieldValues.splice(cfnvIndex,1);
            this.selectedCfnv = this.selectedCfn.customFieldValues.length > 0 ? this.selectedCfn.customFieldValues[0] : null;
        }
    }
    hhListvalueAdd():void {
        if(this.hhListValueAddText.length != 0){
            var cfnv = new CustomFieldValue(this.selectedHandheldCfn.name,this.selectedHandheldCfn.customFieldValues.length,this.hhListValueAddText);
            this.selectedHandheldCfn.customFieldValues.push(cfnv);
        }
    }
    hhListvalueRemove():void{
        if(this.selectedHhCfnv != null){
            var cfnvIndex = this.selectedHandheldCfn.customFieldValues.indexOf(this.selectedHhCfnv);
            this.selectedHandheldCfn.customFieldValues.splice(cfnvIndex,1);
            this.selectedHhCfnv = this.selectedHandheldCfn.customFieldValues.length > 0 ? this.selectedHandheldCfn.customFieldValues[0] : null;
        }
    }

}
